import { Badge, BadgeIcon } from "@components/Badge";
import { Image } from "@components/Image";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { useBroadcastStatusDataQuery } from "@storage/queries/broadcast/useBroadcastStatusDataQuery";

import { cn } from "@lib/utils";

import { ICON_PATHS } from "@configs/icons";

const BADGE_SIZE = "w-[24px] h-[40px]";
const DOT_CLASS = "w-2 h-2 border-none";

type StatusItem =
	{ type: "label"; label: string; isActive: boolean } | { type: "icon"; icon: React.ReactNode; isActive: boolean };

const StatusBadge = ({ content, isActive }: { content: React.ReactNode; isActive: boolean }) => (
	<Badge variant={isActive ? "secondary" : "block"} className={BADGE_SIZE}>
		<Stack align="center" justify="center" spacing={5} wide>
			{content}
			<BadgeIcon className={cn(DOT_CLASS, isActive ? "bg-primary" : "bg-secondary")} variant="primary" />
		</Stack>
	</Badge>
);

export const BroadcastStatusBar = () => {
	const { is3DStreamActive, is2DStreamActive, hasMask } = useBroadcastStatusDataQuery();

	const items: StatusItem[] = [
		{ type: "label", label: "VR", isActive: is3DStreamActive },
		{ type: "label", label: "2D", isActive: is2DStreamActive },
		{
			type: "icon",
			icon: <Image src={ICON_PATHS.PT_MASK} alt="pt_mask" height={12} width={12} />,
			isActive: hasMask,
		},
	];

	return (
		<Stack spacing={2} direction="row" className="mr-0.5">
			{items.map((item) => (
				<StatusBadge
					key={item.type === "label" ? item.label : "mask"}
					content={
						item.type === "label" ? (
							<Typography type="span" align="center" padding="none" weight="bold" className="text-[10px]">
								{item.label}
							</Typography>
						) : (
							item.icon
						)
					}
					isActive={item.isActive}
				/>
			))}
		</Stack>
	);
};
